import { ServiceWithSession } from './base-service';
import type { FormSession } from './form-session';
import type { SavedCardReuseViewModel } from '@cognitoforms/types/server-types/payment/view-models/saved-card-reuse-view-model';

export default class PaymentService extends ServiceWithSession {
	constructor(session: FormSession) {
		super(session);
	}

	async createOrder(orderAmount: number, currencyCode: string, formId: string, clientToken: string) {
		return this.serviceRequest({
			method: 'POST',
			endpoint: 'svc/paypal-form/create-order',
			data: {
				OrderAmount: orderAmount,
				CurrencyCode: currencyCode,
				FormId: formId,
				ClientToken: clientToken
			},
			headers: this.getValidationHeaders()
		});
	}

	async getIdentifier(token: string, paymentMethod: string, clientToken: string) {
		return this.serviceRequest({
			method: 'GET',
			endpoint: `svc/paypal-form/identifier?payPalToken=${token}&paymentMethod=${paymentMethod}&clientToken=${clientToken}`,
			headers: this.getValidationHeaders()
		});
	}

	async getPayPalConfig(): Promise<PayPalClientConfig> {
		const result = await this.serviceRequest({
			method: 'GET',
			endpoint: 'svc/paypal-form/client-config',
			params: { formId: this.session.formId },
			headers: this.getValidationHeaders()
		});

		return result.response.data as PayPalClientConfig;
	}

	async getSavedCardsForForm(): Promise<SavedCardReuseViewModel> {
		const empty: SavedCardReuseViewModel = { SubmitterIdentifier: '', SavedPaymentMethods: [] };

		const result = await this.serviceRequest({
			method: 'GET',
			endpoint: `svc/forms/${this.session.formId}/saved-cards`,
			headers: this.getValidationHeaders()
		});

		if (result.error || !result.response?.data)
			return empty;

		return result.response.data as SavedCardReuseViewModel;
	}

	async deleteSavedCardForForm(paymentMethodId: string): Promise<void> {
		const result = await this.serviceRequest({
			method: 'DELETE',
			endpoint: `svc/forms/${this.session.formId}/saved-cards/${encodeURIComponent(paymentMethodId)}`,
			headers: this.getValidationHeaders()
		});

		if (result.error)
			throw this.parseError(result.error);
	}
}

export type PayPalClientConfig = {
	ClientToken: string;
	MerchantId: string;
	TrackingId: string;
};